<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span class="text-subtitle2">بررسی و تعیین نقطه جوش محصولات</span>
        <template v-slot:action v-if="isDialog">
          <q-btn icon="close" flat v-close-popup round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="q-pa-sm">
      <q-select v-model="selectedGoodsGroup"
                label="انتخاب گروه محصولات"
                use-input
                :options="goodsGroupOptions"
                option-label="Group_Name"
                option-value="Group_Id"
                @filter="goodsGroupFilterFn"
                filled
                map-options
                use-chips
                emit-value
      >
        <template v-slot:after>
          <q-btn icon="done" @click="exportSelectedItems" v-if="isSelectList" round color="indigo" text-color="white"/>
          <q-btn icon="print" @click="loadReport" v-if="isApply" round color="indigo" text-color="white">
            <q-tooltip>
              چاپ
            </q-tooltip>
          </q-btn>
        </template>
      </q-select>
    </q-card-section>
    <q-card-section v-if="this.goodsItems && this.goodsItems.length>0">
      <q-toggle v-model="selectAll" label="انتخاب همه"/>
      <q-toggle v-model="storageBoilingPointList" label="سر رسید نقطه جوش"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          class="my-sticky-header-table"
          :data="goodsItemsOptions"
          :columns="columns"
          row-key="Goods_ID"
          flat
          bordered
          :hide-header="$q.screen.lt.md"
          wrap-cells
          separator="cell"
          binary-state-sort
          :filter="filter"
          :pagination="pagination">
        <template v-slot:body="props">
          <q-tr :props="props" v-if="!$q.screen.lt.md">
            <q-td v-if="isSelectList">
              <q-toggle :true-value="1" :false-value="0" v-model="props.row.Checked"/>
            </q-td>
            <q-td key="Goods_Code" :props="props">
              <q-chip :label="props.row.Goods_Code" square color="red" text-color="white" clickable
                      @click="showProductDetailsDialog(props.row)"/>
            </q-td>
            <q-td key="Goods_Name" class="text-left" :props="props">
              {{ props.row.Goods_Name }}
            </q-td>
            <q-td key="Unit_Name" :props="props">
              {{ props.row.Unit_Name }}
            </q-td>
            <q-td key="Goods_Stock" :props="props">
              {{ props.row.Goods_Stock }}
            </q-td>
            <q-td key="Goods_Pak" :props="props">
              {{ props.row.Goods_Pak }}
            </q-td>
            <q-td key="Goods_Box" :props="props">
              {{ props.row.Goods_Box }}
            </q-td>
            <q-td key="SaleG_CountRemain" :props="props">
              {{ props.row.SaleG_CountRemain }}
            </q-td>
            <q-td key="Goods_Min" :props="props">
              {{ props.row.Goods_Min }}
            </q-td>
          </q-tr>
          <q-tr :props="props" v-if="$q.screen.lt.md">
            <q-card class="q-mb-sm">
              <q-card-section>
                <q-list bordered separator dense>
                  <q-item active>
                    <q-item-section>{{ props.row.Goods_Name }}</q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>انتخاب محصول</q-item-section>
                    <q-item-section side>
                      <q-toggle :true-value="1" :false-value="0" v-model="props.row.Checked"/>
                    </q-item-section>
                  </q-item>

                  <q-item>
                    <q-item-section>شناسه</q-item-section>
                    <q-item-section side>
                      <q-chip :label="props.row.Goods_Code" square color="red" text-color="white" clickable
                              @click="showProductDetailsDialog(props.row)"/>
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>واحد شمارش</q-item-section>
                    <q-item-section side>
                      {{ props.row.Unit_Name }}
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>موجودی</q-item-section>
                    <q-item-section side>
                      {{ props.row.Goods_Stock }}
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>تعداد در جعبه</q-item-section>
                    <q-item-section side>
                      {{ props.row.Goods_Box }}
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>تعداد در کارتن</q-item-section>
                    <q-item-section side>
                      {{ props.row.Goods_Pak }}
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>مانده سفارش</q-item-section>
                    <q-item-section side>
                      {{ props.row.SaleG_CountRemain }}
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section>نقطه جوش</q-item-section>
                    <q-item-section side>
                      {{ props.row.Goods_Min }}
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-card-section>
            </q-card>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        :maximized="$q.screen.lt.md"
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "StorageBoilingPoint",
  components: {ProductDetail},
  props: {
    groupId: {
      type: Number,
      default: () => undefined
    },
    isDialog: {
      type: Boolean,
      default: () => false
    },
    isSelectList: {
      type: Boolean,
      default: () => false
    },
    isApply: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      selectAll: false,
      storageBoilingPointList: false,
      remainOrderList: false,
      selectedGoodsGroup: undefined,
      selectedProductDetails: undefined,
      goodsGroup: [],
      goodsGroupOptions: [],
      goodsItems: [],
      goodsItemsOptions: [],
      pagination: {
        sortBy: 'title',
        rowsPerPage: 500
      },
      filter: undefined,
      showProductDetails: false,
      columns: [
        {
          name: 'Goods_Code',
          required: true,
          label: 'شناسه',
          align: 'center',
          field: row => row.Cs_Code,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Name',
          required: true,
          label: 'عنوان',
          align: 'center',
          field: row => row.Goods_Name,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Unit_Name',
          required: true,
          label: 'واحد',
          align: 'center',
          field: row => row.Unit_Name,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Stock',
          required: true,
          label: 'موجودی',
          align: 'center',
          field: row => row.Goods_Stock,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Pak',
          required: true,
          label: 'تعداد در کارتن',
          align: 'center',
          field: row => row.Goods_Pak,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Box',
          required: true,
          label: 'تعداد در جعبه',
          align: 'center',
          field: row => row.Goods_Box,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'SaleG_CountRemain',
          required: true,
          label: 'مانده سفارش',
          align: 'center',
          field: row => row.SaleG_CountRemain,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Min',
          required: true,
          label: 'نقطه جوش',
          align: 'center',
          field: row => row.Goods_Min,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
      ]
    }
  },
  methods: {
    ...mapActions({
      getGroupList: 'Products/getGoodsGroup',
      getProductDetails: 'Products/getByID',
      getProductsByGroupId: 'Products/getByGroupID',
    }),
    async loadReport() {
      if (this.selectedGoodsGroup === undefined) return
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات خرید/فرم نقطه جوش گروه کالا?rs:Format=PDF&GroupCode=${this.selectedGoodsGroup.Group_ID}&GroupName=${this.selectedGoodsGroup.Group_Name}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    exportSelectedItems() {
      const itemsSelected = this.goodsItemsOptions.filter(item => item.Checked === 1)
      itemsSelected.forEach(item => item.selectedCount = (item.Goods_Min - item.Goods_Stock) + item.SaleG_CountRemain)
      this.$emit('selected-items', itemsSelected)
    },
    showProductDetailsDialog(row) {
      this.getProductDetails(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
    goodsGroupFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.options = []
        })
        return
      }
      update(() => {
        this.goodsGroupOptions = this.goodsGroup.filter(v => v.Group_Name.toLowerCase().indexOf(val) > -1)
      })
    },
  },
  watch: {
    selectAll: function (val) {
      if (val) {
        this.goodsItemsOptions.forEach(item => item.Checked = 1)
      } else {
        this.goodsItemsOptions.forEach(item => item.Checked = 0)
      }
    },
    selectedGoodsGroup: function (val) {
      if (val) {
        this.goodsItems = []
        this.goodsItemsOptions = []
        this.getProductsByGroupId(val.Group_ID).then((res) => {
          this.goodsItems = res
          this.goodsItemsOptions = this.goodsItems
        })
      } else {
        this.goodsItems = []
      }
    },
    storageBoilingPointList: function (val) {
      if (val) {
        if (this.goodsItems && this.goodsItems.length > 0) {
          this.goodsItemsOptions = this.goodsItems.filter(item => item.Goods_Min > 0 && item.Goods_Stock < item.Goods_Min)
        }
      } else {
        this.goodsItemsOptions = this.goodsItems
      }
    }
  },
  created() {
    if (this.isSelectList) {
      this.columns.unshift({})
    }
    this.getGroupList().then((res) => {
      this.goodsGroup = res
      this.goodsGroupOptions = this.goodsGroup
    })
  }
}
</script>

<style lang="sass">
.my-sticky-header-table
  height: 81vh

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    background-color: #455a64
    color: white

  thead tr th
    position: sticky
    z-index: 1

  thead tr:first-child th
    top: 0


  &.q-table--loading thead tr:last-child th
    top: 48px

  tbody
    scroll-margin-top: 48px
</style>